/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseclasses/guid.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipManager {

    export function meevoDateDayOfWeekFilter() {
        return (input: string): string => {

            if (!input) {
                return "";
            }

            return moment(input).format('dddd');
        };
    }


    angular.module("meevo.plugins.membershipManager")
        .filter("meevoDateDayOfWeekFilter", meevoDateDayOfWeekFilter);
}
